import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ToastrService } from 'ngx-toastr';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

import { ConfirmComponent } from '../../modals';
import { MeetingsService } from '../../services';

export interface NotificationGroupsModel {
	title:string;
	button:string;
    label:string;
    groups:Array<any>;
    edit: boolean;
    notification_ended: boolean;
    survey_status: number;
}

@Component({  
    selector: 'notification-groups',
    templateUrl: './notification-groups.html',
    styleUrls: ['./notification-groups.scss']
})

export class NotificationGroupsComponent extends DialogComponent<NotificationGroupsModel, any> implements NotificationGroupsModel, OnInit {
  	title:string;
    button:string;
  	label:string;
    groups:Array<any>;
    edit: boolean;
    notification_ended: boolean;
    survey_status: number;

    data = [];
    filterQuery = '';
    rowsOnPage = 10;
    sortBy = 'name';
    sortOrder = 'asc';

    private searchForm: FormGroup;
    private search:AbstractControl;
    private groups_control:AbstractControl;

    private filter_term:string;
    
    private groups_arr = [];
    private dropdownSettings: IMultiSelectSettings = {
        enableSearch: false,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-default btn-block',
        dynamicTitleMaxItems: 10,
        fixedTitle: true,
        closeOnClickOutside: false,
        selectionLimit: 1,
        autoUnselect: true,
        containerClasses: 'dropdown-members'
    };

    private groups_text: IMultiSelectTexts = {
        searchPlaceholder: 'Pronađi grupu Članova',
        searchEmptyResult: 'Nije pronađena niti jedna grupa članova...',
        defaultTitle: 'Dodaj grupu članova...',
    };

    private search_error_msg:boolean = false;
    private errorMsg:string = '';

  	constructor(
        dialogService: DialogService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private slimLoader: SlimLoadingBarService,
        private meetingsService: MeetingsService
    ) {
    	super(dialogService);
  	}

    // For datatables
    toInt(num: string) {
        return +num;
    }

    ngOnInit() {
        this.searchForm = this.formBuilder.group({
            search: [''],
            groups_control: []
        });

        this.search = this.searchForm.controls['search'];

        this.searchForm.controls['groups_control'].valueChanges.subscribe((value) => {
            if(value !== null){
                if(value.length > 0){
                    for(let i = 0; i < value.length; i++){
                        this.addGroup(value[i]);
                    }
                }
            }
        });

        if(this.groups.length > 0){
            for( let i = 0; i < this.groups.length; i++){
                if(this.groups[i].group_id){
                    this.groups[i].id = this.groups[i].group_id;
                }
                this.data.push(this.groups[i]);
            }
        }
    }

    // Add group function
    addGroup(value) {
        this.searchForm.controls.groups_control.reset();
        let found = this.data.some(function (el) {
            return el.id === value;
        });
        if (!found) {
            for( let i = 0; i < this.groups_arr.length; i++){
                if(this.groups_arr[i].id === value){
                    let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                        title:'Dodaj grupu članova', 
                        message:'Jeste li sigurni da želite dodati ' + this.groups_arr[i].name + ' ?',
                        button: 'Dodaj',
                    })
                    .subscribe((isConfirmed)=>{
                        if(isConfirmed) {
                            //Add group to datatable
                            this.data.push(this.groups_arr[i]);
                            this.toastr.success("Uspješno ste dodali grupu članova");
                        }
                    });
                }
            }
        } else {
            this.toastr.error("Grupa članova je već dodana!");
        }
    }

    searchGroups(term){
        this.filter_term = term;
        
        this.meetingsService.getMeetingMembers(this.filter_term).subscribe(
            response => {
                if(response.groups.length > 0){
                    this.search_error_msg = false;
                } else {
                    this.search_error_msg = true;
                }
                this.groups_arr = response.groups;
                this.slimLoader.complete();
            },
            error => {
                if(error.error_msg){
                    this.toastr.error(error.error_msg);
                    this.errorMsg = error.error_msg;
                    this.slimLoader.complete();
                }
            },
        );
    }

    //Delete group from datatable
    onDeleteGroup(group){
        let activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title:'Izbriši grupu članova', 
            message:'Jeste li sigurni da želite izbrisati ' + group.name + ' ?',
            button: 'Izbriši',
        })
        .subscribe((isConfirmed)=>{
            if(isConfirmed) {
                let id = group.id;
                const toDelete = new Set([id]);

                //Remove user from datatable
                this.data = this.data.filter(obj => !toDelete.has(obj.id));
                this.toastr.success("Uspješno ste izbrisali grupu članova");
                this.searchForm.controls.groups_control.reset();
            }
        });
    }

  	confirm(data) {
    	// we set dialog result as true on click on confirm button, 
    	// then we can get dialog result from caller code
    	this.result = data;
    	this.close();
  	}
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/notification-groups/notification-groups.component.ts